import React from 'react';
import EmployeeLookup from "../assets/images/employee-lookup.svg";
import VendorSearch from "../assets/images/vender-search.svg";
import AuditReports from "../assets/images/audit-reports.svg";

const QuickTools = () => {
  return (
    <section className="py-5" style={{backgroundColor: "#ffffff;"}}>
        <div className="container">
            <div className="text-center mb-5">
                <h1 className="display-5 fw-bold mb-3">Quick Tools</h1>
            </div>
            <div className="row g-4 justify-content-center">
                <div className="col-lg-3 col-md-4 col-sm-6">
                    <div className="quick-tools-card">
                        <div className="quick-tools-icon icon-employees">
                            <a href="/employees/employee-search" target="_blank" 
                rel="noopener noreferrer">
                              <img
                              src={EmployeeLookup}
                              alt="Employee Lookup"
                              className="quick-tools-svg"
                            />
                            </a>
                        </div>
                        <span className="quick-tools-title">Employee Look Up</span>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                    <div className="quick-tools-card">
                        <div className="quick-tools-icon icon-entities">
                            <a href="https://old.transparent.utah.gov/vendet.php" target="_blank" 
                rel="noopener noreferrer">
                              <img
                              src={VendorSearch}
                              alt="Vendor Search"
                              className="quick-tools-svg"
                              />
                            </a>
                        </div>
                        <span className="quick-tools-title">Vendor Search</span>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                    <div className="quick-tools-card">
                        <div className="quick-tools-icon icon-education">
                            <a href="https://auditor.utah.gov/audit-reports/" target="_blank" 
                rel="noopener noreferrer">
                              <img
                              src={AuditReports}
                              alt="Audit Reports"
                              className="quick-tools-svg"
                              />
                            </a>
                        </div>
                        <span className="quick-tools-title">Audits and Reports</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default QuickTools